import api from "@/services/api"
const { get, post } = api
export const signIn = (email: string, password: string) => {
    return post(`/ajax/me/email-login`, {
        email,
        password,

    });
};
const BASE_PARAMS = {
    platform: 2,
    distribution: "",
    version: 0
}
export const googleSignInAPI = (
    access_token: string,
    expires_in: string,
    googleId: string
) => {
    return post(`/user/other-login`, {
        access_token,
        expires_in,
        isV2: true,
        sid: googleId,
        token_from: 10,
        ...BASE_PARAMS
    });
};


export const appleSignInAPI = (
    access_token: string,
    expires_in: string,
    appleId: string
) => {
    return post(`/user/other-login`, {
        access_token,
        expires_in,
        isV2: true,
        sid: appleId,
        token_from: 12,
        ...BASE_PARAMS
    });
};

export const getUserInfo = () => {
    return get(`/user/info`);
};
